import { registerInlineValidationListener } from "./registerInlineValidationListener"
import { ValidatedComponent } from "./validatedComponent"

type ValidationFunction = (signal: AbortSignal) => PromiseLike<string | undefined>

export function validateFieldWith(
    field: ValidatedComponent,
    validationFunction: ValidationFunction,
    validationVisibilityHandler?: () => boolean,
) {
    async function validate(abortSignal: AbortSignal) {
        field.validationResult = await validationFunction(abortSignal)
    }

    registerInlineValidationListener(
        field,
        (abortSignal: AbortSignal) => {
            validate(abortSignal).catch((e: unknown) => {
                if (!abortSignal.aborted) console.error(e)
            })
        },
        validationVisibilityHandler,
    )
}
